import styled from 'styled-components';

const IconContainer = styled.div<any>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16px;
  margin: 12px 16px;
  color: ${(props) => props.theme.colors.grey8};
`;

export default IconContainer;
